export default {
  messages: {
    UNKNOWN_ERROR: "Unknown error. Please contact the administrator!",
  }
}